import request from '@/utils/request'

// 查询租户列表
export function queryTenantPage(data) {
  return request({
    url: '/tenant/page',
    method: 'post',
    data: data
  })
}

// 新增租户
export function saveTenant(data) {
  return request({
    url: '/tenant/save',
    method: 'post',
    data: data
  })
}
// 查询租户申请列表
export function queryApplyList(data) {
  return request({
    url: '/tenant/applyList',
    method: 'post',
    data: data
  })
}

// 删除组织成员
export function deleteTenantMember(data) {
  return request({
    url: '/tenant/groupMember/delete',
    method: 'post',
    data: data
  })
}

// 查询组织成员列表
export function queryMemberList(data) {
  return request({
    url: '/tenant/groupMember/page',
    method: 'post',
    data: data
  })
}

// 保存组织成员
export function saveMember(data) {
  return request({
    url: '/tenant/groupMember/save',
    method: 'post',
    data: data
  })
}

// 查询加入等组织成员
export function joinGroupList(data) {
  return request({
    url: '/tenant/groupMember/joinGroupList',
    method: 'post',
    data: data
  })
}

// 查询是否入驻
export function checkByName(data) {
  return request({
    url: '/tenant/listByName',
    method: 'post',
    data: data
  })
}

// 查询租户申请未跟进数量
export function applyUnfollowCount() {
  return request({
    url: '/tenant/applyUnfollowCount',
    method: 'get'
  })
}


// 租户申请跟进
export function applyFollow(data) {
  return request({
    url: '/tenant/applyFollow',
    method: 'post',
    data: data
  })
}


